import React from "react";

import { useHistory } from "react-router-dom";

import BackgroundImageSection from "./section/BackgroundImageSection";
import { TypeEnum } from "../../../api/ProjectAPI.types";
import "../../../css/admin/platform.scss";

import type { JSX } from "react";

import type { Project } from "../../../api/ProjectAPI.types";

interface OffersPageEditorProps {
  project: Project;
}

function OffersPageEditor({
  project,
}: OffersPageEditorProps): JSX.Element | null {
  const history = useHistory();

  if (project.type === TypeEnum.Edu) {
    history.push("/layout");
    return null;
  }

  return (
    <div className="platform-configuration editor-tile-container editor-form-container">
      <div className="editor-form-signup-container">
        <BackgroundImageSection component="offer" />
      </div>
    </div>
  );
}

export default OffersPageEditor;
